import { STATS_GET_ONBOARDING_REQUESTING } from "./constants";

export const getOnboardingStatsRequest = (payload: { clientId: string }) => {
  return {
    type: STATS_GET_ONBOARDING_REQUESTING,
    payload
  };
};
